export const equals = (a, b) => a === b;

export function isObjectPropsEquals(a, b) {
    if (!a || !b) return false;

    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    for (const key of aKeys) {
        if (!bKeys.includes(key)) return false;

        if (a[key] !== b[key]) return false;
    }

    return true;
}
